<template>
    <div class="content">
     <!-- <keep-alive> -->
      <router-view></router-view>
     <!-- </keep-alive> -->
           
    
 <Footer></Footer>
  </div>
</template>

<script>
import Footer from "./Footer.vue";

export default {
  components: {
    Footer
  },
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/dashboard/subViews/Content.vue